import { render, staticRenderFns } from "./financialLvYou.vue?vue&type=template&id=f2275552&scoped=true"
import script from "./financialLvYou.vue?vue&type=script&lang=js"
export * from "./financialLvYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2275552",
  null
  
)

export default component.exports